import axios from 'axios';
import {useCallback, useEffect, useState} from 'react'

const useFetch = (url,autoLoad=true) => {
    const [data,setData] = useState(null);
    const [loading,setLoading] = useState(Boolean(autoLoad && url));
    const [error,setError]  = useState(null);
    const token = localStorage.getItem('token');

    const fetchData = useCallback(async ()=>{
        if (!url) {
            setData(null);
            setError(null);
            setLoading(false);
            return null;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(url,{
                headers:{
                    'Authorization': `Bearer ${token}` 
                },
                validateStatus: () => true
            });
            if (response.status >= 200 && response.status < 300) {
                setData(response.data);
                setLoading(false);
                return response.data;
            }
            setData(null);
            setError({
                message: response?.data?.message || `Request failed with status ${response.status}`,
                status: response.status,
                data: response.data
            });
            setLoading(false);
            return null;
        }catch(error){
            setData(null);
            setError(error);
            setLoading(false);
            return null;
        }
    }, [token, url]);

    const refreshHandler = useCallback(() => {
        return fetchData();
    }, [fetchData]);

    useEffect(()=>{
        if(autoLoad && url){
            fetchData();
            return () => {
                // Cleanup or cancel ongoing requests if needed
            }
        }
        setLoading(false);
    },[url, autoLoad, fetchData])

    return {data,loading,error,fetchData,refreshHandler}
}

export default useFetch
